import React, { useEffect, useState } from "react";
import "./phone.style.scss";
import { Button, Input } from "antd";
import { get, responseValidator } from "../../api";
import { toast } from "react-toastify";
import { Link } from "react-router-dom"
import createHistory from "history/createBrowserHistory";
const history2 = createHistory();

export default function Phone(props) {
    const [pn, setPn] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        localStorage.clear();
    }, []);
    function onCLickHandler() {
        if (pn.length === 11 && pn.substring(0, 2) === "09") {
            setLoading(true);
            get(`/User/Exist/${pn}`).then(response => {
                setLoading(false);
                if (responseValidator(response.status)) {
                    localStorage.setItem("phone", pn);
                    console.log(response.data.data);
                    if (response.data.data.userIsExist) {
                        history2.push('/enterPassword')
                        props.changeState(4);
                    }
                    else props.changeState(2);
                } else toast.error(response.data.message);
            });
        }

    }

    return (
        <div className="TEMX-phone">
            <h2>ورود/ثبت نام</h2>
            <p>شماره موبایل خود را وارد کنید.</p>
            <Input
                type={"number"}
                onPressEnter={onCLickHandler}
                onChange={e => setPn(e.target.value)}
                placeholder="مثلا 09123456789"
            />
            <div className="my-btn">
                <Button
                    loading={loading}
                    disabled={pn.length !== 11 || pn.substring(0, 2) !== "09"}
                    block
                    type="primary"
                    onClick={onCLickHandler}
                >
                    ورود
                </Button>
                <Link to="/">
                    <Button
                        block
                        type="secondary"
                    >
                        بازگشت به صفحه اصلی
                    </Button>
                </Link>


            </div>
        </div>
    );
}
